import { createI18n } from 'vue-i18n'
import enCA from '@/i18n/en-CA.json'
import frCA from '@/i18n/fr-CA.json'
import { getStoredCulture } from '@/utils/culture'

export var i18n = createI18n({
  legacy: false,
  locale: getStoredCulture(),
  fallbackLocale: {
    'fr-CA': ['en-CA'],
    'en-CA': ['en-CA'],
  },
  messages: {
    'en-CA': enCA,
    'fr-CA': frCA,
  },
})
